import i18n from "i18next";

export const tGlobal = (key: string, options?: any): string => {
  return i18n.t(key, options) as string;
};

export const nsT = (ns: string) => {
  return (key: string, options?: any): string =>
    i18n.t(`${ns}.${key}`, options) as string;
};
